import { render } from "./GrantsComponent.vue?vue&type=template&id=edbf11e8&scoped=true"
import script from "./GrantsComponent.vue?vue&type=script&lang=js"
export * from "./GrantsComponent.vue?vue&type=script&lang=js"

import "./GrantsComponent.vue?vue&type=style&index=0&id=edbf11e8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edbf11e8"]])

export default __exports__